import { render, staticRenderFns } from "./companyEmployeeOrdersDialog.vue?vue&type=template&id=7b4cba08"
import script from "./companyEmployeeOrdersDialog.vue?vue&type=script&lang=js"
export * from "./companyEmployeeOrdersDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports